import React from "react";
import { Box, Skeleton, IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";

const CrossingTradesTableSkeleton = () => {
  return (
    <Box
      sx={{
        borderRadius: "4px",
        marginTop: "1px",
        width: "100%",
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2, flexShrink: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", marginRight: 2 }}>
          <Box sx={{ width: 20, height: 20, backgroundColor: "#add8e6", marginRight: 1 }} />
          <Skeleton variant="text" width={200} height={20} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ width: 20, height: 20, backgroundColor: "#e0e0e0", marginRight: 1 }} />
          <Skeleton variant="text" width={220} height={20} />
        </Box>
        <Box sx={{ marginLeft: "auto" }}>
          <Skeleton variant="rectangular" width={120} height={32} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginTop: "-30px", flexShrink: 0 }}>
        <Skeleton variant="text" width={180} height={20} />
        <IconButton sx={{ fontSize: 40 }}>
          <ToggleOffIcon sx={{ fontSize: 40 }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          marginTop: "1px",
          width: "100%",
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ display: "flex", p: 1.5, borderBottom: "1px solid #e0e0e0", flexShrink: 0 }}>
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton key={index} variant="text" width={80} height={24} sx={{ mr: 2 }} />
          ))}
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", p: 1.5 }}>
          {Array.from({ length: 20 }).map((_, index) => (
            <Box key={index} sx={{ display: "flex", mb: 1, py: 0.5 }}>
              {Array.from({ length: 8 }).map((__, colIndex) => (
                <Skeleton key={colIndex} variant="text" width={80} height={16} sx={{ mr: 2 }} />
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CrossingTradesTableSkeleton;
